import script from "./BackOfficesView.vue?vue&type=script&setup=true&lang=js"
export * from "./BackOfficesView.vue?vue&type=script&setup=true&lang=js"

import "./BackOfficesView.vue?vue&type=style&index=0&id=67372351&lang=scss"

const __exports__ = script;

export default __exports__